// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-tile-link----styles-module---container---2zIhH","inner":"src-components-tile-link----styles-module---inner---b5KNA","title":"src-components-tile-link----styles-module---title---1Q3h0","text":"src-components-tile-link----styles-module---text---2RkiM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/tile-link/styles.module.css
// module id = 236
// module chunks = 35783957827783 69062039818352